import React from "react";
import styled from "styled-components";
import { Card } from "../../../design-system";
import { theme } from "../../../design-system/theme";

const PageWrap = styled.div`
  max-width: 1440px;
  width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding: ${theme.spacing.sm} 0 ${theme.spacing.xl};
`;

const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.md};
`;

/** Card body: min-width allows nested tables to use horizontal overflow instead of stretching the page. */
const ReportCard = styled(Card)`
  min-width: 0;
`;

/**
 * Standard layout for Manage Reports V2: optional toolbar (CSV, etc.) above the card; filters + table inside the card.
 */
export default function ReportPageShell({ toolbar, children }) {
  return (
    <PageWrap>
      {toolbar ? <Toolbar>{toolbar}</Toolbar> : null}
      <ReportCard>{children}</ReportCard>
    </PageWrap>
  );
}
